import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as CampanhasActions } from "../ducks/campanhas";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";
import { Creators as ModalDocsActions } from "../ducks/modalDocs";

export function* getListCampanhas() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(
      state => state.campanhas
    );
    const { data } = yield call(
      api.post,
      `/campaigns/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const { data: campanhas, total } = data;
    let campanhasPayload = [];
    campanhasPayload = campanhas.map(campanha => ({
      id: campanha.id,
      name: campanha.name,
      inactived: campanha.inactived,
      customers: `<span style="display: flex; justify-content: flex-end; width: 100%;">${
        campanha.total_customer
      }</span>`,
      customers_called: `<span style="display: flex; justify-content: flex-end; width: 100%;">${
        campanha.total_customer_called
      }</span>`,
      customers_not_called: `<span style="display: flex; justify-content: flex-end; width: 100%;">${
        campanha.total_customer_free
      }</span>`,
      customers_jumped:
        campanha.total_customer_transferred > 0
          ? `<span style="display: flex; justify-content: flex-end; width: 100%;"><span style="text-align: center; position: relative; width: 3.5rem; font-size: 1.1rem !important; font-weight: bold;  height: 2rem; display: flex; align-items: center; justify-content: center; color: #ffffff; background: rgba(0,0,0, .7); border-radius: 5px; ">${
              campanha.total_customer_transferred
            }</span></span>`
          : "",
      percent: `<span style="display: flex; justify-content: flex-end; width: 100%;"><span style="text-align: center; position: relative; width: 5.2rem;  height: 2rem; display: flex; font-size: 1.1rem !important; font-weight: bold; align-items: center; justify-content: center; border-radius: 5px;  padding:0 .5rem; background-color: ${
        parseInt(campanha.percent_customer_called, 10) < 25
          ? "#2a9500"
          : parseInt(campanha.percent_customer_called, 10) < 50
          ? "#859500"
          : parseInt(campanha.percent_customer_called, 10) < 75
          ? "#cdc213"
          : parseInt(campanha.percent_customer_called, 10) < 95
          ? "#c8500e"
          : "#b50000"
      }; color: #ffffff;">${campanha.percent_customer_called}%</span></span>`,
      users: `<span style="display: flex; justify-content: flex-end; width: 100%;">${
        campanha.users_count
      }</span>`
    }));
    const name = "Campanhas";
    const path = "campanhas";
    yield put(PageActions.setPage(name, path));
    yield put(
      CampanhasActions.getListCampanhasSuccess(campanhasPayload, total)
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getCampanhas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/campaigns/${payload.id}`);
    yield put(CampanhasActions.getCampanhasSuccess(data));
    const { action } = yield select(state => state.campanhasStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    } else if (action === "DOCS") {
      yield put(ModalDocsActions.openDocsModal());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editCampanhas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/campaigns/${payload.id}`, payload);
    yield put(CampanhasActions.getListCampanhas());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addCampanhas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/campaigns`, payload);
    yield put(CampanhasActions.searchCampanhas({}));
    yield put(CampanhasActions.getListCampanhas());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteCampanhas() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.campanhas.item);
    yield call(api.delete, `/campaigns/${id}`);
    yield put(CampanhasActions.getListCampanhas());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchCampanhas() {
  try {
    yield put(CampanhasActions.getListCampanhas());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllCampanhas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/campaigns/destroy-many`, {
      campaigns_id: payload.selected
    });
    yield put(CampanhasActions.getListCampanhas());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/campanhas.js